import { OFFICE_LOCATION_CONTENT, OfficeLocations } from 'components/Pages/AboutUsPage/OfficeLocationModal/OfficeLocationModal'

export type RetailStoreType = 'bondi' | 'chadstone'

export const STORE_CAMPAIGN_URL = '/campaign/store'

const RETAIL_STORE_LOCATIONS: Record<RetailStoreType, OfficeLocations> = {
  bondi: OfficeLocations.BONDI,
  chadstone: OfficeLocations.CHADSTONE,
}

export function getRetailStoreContent(storeType: RetailStoreType) {
  const location = RETAIL_STORE_LOCATIONS[storeType]
  const office = OFFICE_LOCATION_CONTENT.offices.find(o => o.location === location)
  if (!office) {
    throw new Error(`Retail store not found: ${storeType}`)
  }
  return {
    title: office.officeTitle,
    address: office.address,
    imageId: office.imageId,
  }
}
